import React, { useState, useEffect } from 'react'
import { Input, Button, Checkbox } from 'antd'
import { app, api } from 'xadmin';

//图片验证码
const ImageCode = (props) => {
  const [url, setUrl] = useState('')
  const { input: { onChange } } = props

  useEffect(() => {
    getImageCode()
  }, [ localStorage.getItem('resetCode') ])

  const getImageCode = () => {
    const query = { 'height': 36, 'width': 240, 'captchaLen': 4, 'maxSkew': 0.7, 'dotCount': 80 }
    api({ name: 'core/auth/captcha' })
      .fetch('?query=' + JSON.stringify(query), {})
      .then(({ json }) => {
        setUrl(json.data)
        document.getElementsByClassName('codeImg')[0].parentNode.parentNode.lastChild.children[0].style.marginLeft = '18px'
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <div className="codeImg" style={{ display: 'flex' }}>
      <Input style={{ maxWidth: '300px' }} onChange={(value) => onChange(value)} />
      <img className="dark-code" src={url} alt="" onClick={() => { getImageCode() }} style={{ marginLeft: '20px', maxWidth: '100px', maxHeight: '36px', border: '1px solid #ccc' }} />
    </div>
  )
}
//短信验证码
const Code = (props) => {
  const { input: { onChange } } = props
  return (
    <div style={{ display: 'flex' }}>
      <Input style={{ maxWidth: '110px' }} onChange={(value) => onChange(value)} />
      <Button className="getCode" style={{ flex: 1 }}>获取验证码</Button>
    </div>
  )
}
//记住密码
const Remember = (props) => {
  const { input: { onChange, value } } = props
  return (
    <div className="remember-box" style={{ display: 'flex' }}>
      <Checkbox checked={value} onChange={(e) => onChange(e.target.checked)} className="remember-pwd">记住我</Checkbox>
      {/* <span className="remember-pwd remember-r" onClick={()=>app.go('/pwdPage')}>忘记密码？</span> */}
      {/* <span className="remember-pwd remember-r" onClick={()=>app.go('/reg')}>还没有账号？<span style={{ color: '#03a9f4' }}>免费注册</span></span> */}
    </div>
  )
}

export { ImageCode, Code, Remember } 
